
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	const exportFields=[
        {name:'姓名/客户单位',value:'zyxm'},
        {name:'工号/用户名',value:'zydm'},
        {name:'部门',value:'lsbmmc'},
        {name:'登陆时间',value:'dlsj'},
		{name:'登陆IP',value:'dlip'},
        {name:'终端类型',value:'type'}
    ]
	@Component({
		name: 'contractinfo',
		components:{
		}
	})
	export default class contractinfo extends Vue {
		customerVisible=false
		currentNo: number = 1;
		pageSize: number = 10;
		pageTotal: number = 0;
		activeNames=[];
		showbmxxVisible: boolean = false;
		customerList=[]
		showfileVisible=false
		showInfoVisible=false
		contractUserVisible =false
		contractUserInfoVisible= false
		deptdisable=false
		searchForm= {
			startTimest: '',
			startTimeed: '',
			xm:'',
			bmid:'',
			type: ''
		}
		startTime=[]
		endTime=[]
		amount=['','']
		contractList=[]
		loading: boolean = false;
		dataListSelections=[];
		depts= []
		sjbm=[]
		selectBm=''
		created() {
			this.getDepts()
			this.searchData();

		}

		handleSizeChange(val: number) {
			this.pageSize = val;
			this.searchData();
		}
		handleCurrentChange(val: number) {
			this.currentNo = val;
			this.searchData();
		}
		getDepts() {
			let that = this;
			this.$request.get('/bjba/kqtj/getFirstMentForUser',{
				params: {
					userid:this.$store.getters.username
				}

			}).then(res => {
				that.depts = res.data
				if(this.depts && this.depts[0]) {
					var zzdyqc = this.$store.getters.user.zzdyqc;
					if (zzdyqc != this.CONST_ZN_BM) {
						var zw = this.$store.getters.user.zw;
						if (zw) {
							if (zw == '01' || zw == '02' || zw == '03') {
								this.searchForm.bmid = that.depts[0].bmid
								this.deptdisable = true
							}
						}

					}
				}
			})
		}
		preview(row){
			// var viewUrl = this.$request.defaults.baseURL+'/bjba/contract/preview/'+id+'?type=1&access_token='+this.$store.getters.token
			// window.open(viewUrl)
			this.showfileVisible = true
			this.$nextTick(() => {
				this.$refs.showfile.init(row)
			})
		}
		showInfo(row){

			this.showInfoVisible = true
			this.$nextTick(() => {
				this.$refs.showinfo.init(row)
			})
		}
		showContractGdxx(row){

			this.contractUserVisible = true
			this.$nextTick(() => {
				this.$refs.contractUser.init(row)
			})
		}
		showContractGdxxInfo(row){

			this.contractUserInfoVisible = true
			this.$nextTick(() => {
				this.$refs.contractUserInfo.init(row)
			})
		}
		download(id) {
			var downUrl = this.$request.defaults.baseURL+'/bjba/contract/download/'+id+'?type=1&access_token='+this.$store.getters.token
			window.location.href = downUrl
		}
		changeIndex() {
			this.currentNo =1
		}
		exportExcel() {
            var filedLast = exportFields
			this.$refs.fileds.value = JSON.stringify(filedLast)
                this.$refs.exportForm.submit();
        }
		searchData(num) {
			if(this.startTime &&this.startTime.length==2){
				this.searchForm.startTimest = this.startTime[0]
				this.searchForm.startTimeed = this.startTime[1]
			} else{
				this.searchForm.startTimest = ''
				this.searchForm.startTimeed = ''
			}

			if(num) {
				this.searchForm.page = num
			} else {
				this.searchForm.page = this.currentNo
			}
			this.searchForm.pagesize = this.pageSize
			this.loading = true;
			this.$request({
					url: '/bjba/loginlog/logPage',
					method: 'get',
					params: this.searchForm
				})
				.then(response => {
					this.loading = false;
					console.log(response);
					let data = response.data;
					if (data.code == 200) {
						this.contractList = data.data.content;
						this.pageTotal = data.data.totalElements

					} else {
						this.$message.error(data.message)
					}
				})
				.catch(error => {
					this.loading = false;
					console.log(error)
					this.$message.error(error)
				});
		}
		// 多选
		selectionChangeHandle (val) {
			this.dataListSelections = val
		}
		addOrUpdate(val: any) {

			this.customerVisible = true
			this.$nextTick(() => {
				this.$refs.customer.init(val)
			})

		}
		deleteHandle (id) {
			let ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			if(!ids || ids.length==0) return
			this.$confirm(`确定进行[删除]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/bjba/contract/delete`,
					method: 'post',
					data: ids
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500
						})
						this.searchData()
					} else if(data && data.code ==500) {
						this.$message({
							message: data.message,
							type: 'error',
							duration: 1500
						})
					}
				})
			}).catch(() => {
			})
		}
	}
